<script setup lang="ts">
import { ImageMedia } from '@clovyr/bed';

defineProps({
  headingText: {
    type: String,
    default: '',
  },
  imageFilenames: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <div class="instruction-section row">
    <div class="instruction-section__left grid__col-md-6">
      <div class="section-heading">{{ headingText }}</div>
      <slot />
    </div>

    <div class="instruction-section__right grid__col-md-6">
      <ImageMedia
        v-for="(filename, idx) in imageFilenames as string[]"
        :key="idx"
        :filename="filename"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/layout/grid-vars';
@use 'styles/core/typography/type';
@use 'styles/vendor/bootstrap/scss/mixins/breakpoints';

.instruction-section {
  &:not(:first-child) {
    margin-top: grid-vars.space(5);
  }

  &__right {
    margin-top: grid-vars.space(3);

    @include breakpoints.media-breakpoint-up(md) {
      margin-top: 0;
    }
  }

  .section-heading {
    @include type.text--h3;

    margin-bottom: grid-vars.space(1);
  }

  ol {
    padding-left: grid-vars.space(1.8);
    list-style: numeric;
  }

  :deep(.image-media) {
    &:not(:first-child) {
      margin-top: grid-vars.space(2);
    }
  }
}
</style>
